<template>
  <div id="app">
    <web-document-viewer />
  </div>
</template>
<script>
import WebDocumentViewer from "./components/WebDocumentViewer";
export default {
  components: {
    WebDocumentViewer
  }
}
</script>
